import throttle from "../utils/throttle";
const stickyHeader = document.querySelector("#sticky_header");
// It can be the same element as sticky header or element inside sticky header
const stickyHeaderElement = document.querySelector(".js-sticky-header-element");
const bodyElement = document.querySelector("body");
const bodyAffixedStateClass = "l-navbar-affixed";
const headerAffixedStateClass = "is-affixed";
/**
 * Get element offset to top relative to page.
 */
function getElOffsetTop(elem) {
    let offset = 0;
    // Loop up the DOM
    if (elem && elem.offsetParent) {
        do {
            offset += elem.offsetTop;
            elem = elem.offsetParent;
        } while (elem);
    }
    return offset < 0 ? 0 : offset;
}
/**
 * Get height of sticky header.
 */
function getStickyHeaderHeight(element = stickyHeaderElement) {
    return element ? element.clientHeight : 0;
}
/**
 * Keep height of the affixed parent element in order to prevent "jumping page" effect.
 */
function keepHeaderHeight(elem) {
    const parent = elem.parentElement;
    const parentHeight = parent === null || parent === void 0 ? void 0 : parent.offsetHeight;
    if (parent && parentHeight > 0) {
        parent.style.minHeight = `${parentHeight}px`;
    }
}
/**
 * Check if sticky header is in affixed state.
 */
function isHeaderAffixed() {
    return stickyHeader === null || stickyHeader === void 0 ? void 0 : stickyHeader.classList.contains(headerAffixedStateClass);
}
/**
 * Handle toggle of affixed state.
 */
function toggleAffixedState(position) {
    if (window.pageYOffset > position) {
        if (isHeaderAffixed())
            return;
        stickyHeader.classList.add(headerAffixedStateClass);
        bodyElement.classList.add(bodyAffixedStateClass);
    }
    else {
        if (!isHeaderAffixed())
            return;
        stickyHeader.classList.remove(headerAffixedStateClass);
        bodyElement.classList.remove(bodyAffixedStateClass);
    }
}
/**
 * Observe scroll event for changing state of header.
 */
function observeScrollEvent(position) {
    window.addEventListener("scroll", throttle(() => {
        toggleAffixedState(position);
    }, 200));
}
/**
 * Initialize StickyHeader feature.
 */
function init() {
    if (!stickyHeader)
        return;
    const keepHeaderHeightAttr = stickyHeader.dataset.keepHeight;
    const stickyPosition = getElOffsetTop(stickyHeader) + stickyHeader.clientHeight;
    if (keepHeaderHeightAttr != undefined && keepHeaderHeightAttr !== "false") {
        keepHeaderHeight(stickyHeader);
    }
    toggleAffixedState(stickyPosition);
    observeScrollEvent(stickyPosition);
}
/**
 * Sticky Header.
 */
export default {
    data: { stickyHeader, stickyHeaderElement, headerAffixedStateClass },
    utils: { getStickyHeaderHeight, isHeaderAffixed },
    init,
};
